import { EditorEvent } from '../../editor/types';

export abstract class ChecklistPluginEvent extends EditorEvent {
  protected constructor(type: string) {
    super('ChecklistPlugin', type);
  }
}

export class ChecklistPluginChecklistChange extends ChecklistPluginEvent {
  constructor(public state: { doc: object }) {
    super('ChecklistChange');
  }
}

export type ChecklistEvents = ChecklistPluginChecklistChange;
